import React from 'react'
import { useForm } from 'react-hook-form'
import Form, { FormGroup } from '@/shared/ui/Form/Form'
import StringInput, { RichTextInput, TextInput } from '@/shared/ui/Inputs/StringInput'
import Button from '@/shared/ui/Buttons/Button'
import { useNavigate } from 'react-router-dom'
import { ProjectSearch, ReferenceInput } from '@/shared/ui/Inputs/HumanInput'
import api from '@/shared/api/api'
import { BodyCreateTestcasesApiTestCasesPost, TestCaseStatus } from '@/shared/api/gen/data-contracts'
import revalidateData from '@/shared/hooks/revalidateData'
import SelectInput from '@/shared/ui/Inputs/SelectInput'
import { FlexColumn } from '@/shared/ui/Layouts/Flex'


function TestCaseForm({ defaultData, onSubmit }: any) {
    const navigate = useNavigate();
    const { register, handleSubmit, reset, control, formState: { errors } } = useForm<BodyCreateTestcasesApiTestCasesPost>({ defaultValues: defaultData });
    React.useEffect(() => {
        reset(defaultData, { keepDirty: true, keepTouched: true })
    }, [defaultData])
    return (
        <FlexColumn style={{alignItems: "flex-start"}}>
            <h2 className='text-24'>Карточка Тест-кейса</h2>
            <Form onSubmit={handleSubmit((data)=>{onSubmit(revalidateData(data, ["attachment"]))}, (e)=>{console.log("error", e)})} style={{height: "100%", width: "100%", overflow: "hidden"}}>
                
                <StringInput 
                    label="Название тест-кейса*"
                    register={register("title", {required: "обязательное поле"})}
                    error={errors.title?.message}
                />
                <TextInput
                    label="Описание тест-кейса*"
                    register={register("description", {required: "обязательное поле"})}
                    error={errors.description?.message}
                />
                <SelectInput label='Статус теста-кейса' register={register("status")} choices={
                        [
                            {value: TestCaseStatus.DRAFT, title: "Черновик"},
                            {value: TestCaseStatus.READY, title: "Готов к использованию"},
                            {value: TestCaseStatus.DEPRICATED, title: "Устарел"},
                        ]
                } />
                <SelectInput label='Приоритет' register={register("priority")} choices={
                        [
                            {value: 1, title: "1 — Минимальный"},
                            {value: 2, title: "2 — Низкий"},
                            {value: 3, title: "3 — Средний"},
                            {value: 4, title: "4 — Высокий"},
                            {value: 5, title: "5 — Критический"},
                        ]
                } />
                <StringInput
                    label="Теги (через запятую)"
                    register={register("tags")}
                />
                <RichTextInput
                    label="Предварительные условия для теста"
                    name="precondition"
                    style={{minWidth: "200px"}}
                    control={control}
                />
                <RichTextInput
                    label="Шаги выполнения тест-кейса*"
                    name="steps"
                    style={{minWidth: "200px"}}
                    control={control}
                />
                <RichTextInput
                    label="Действия после теста"
                    name="postcondition"
                    style={{minWidth: "200px"}}
                    control={control}
                    error={errors.postcondition?.message}
                />
                <RichTextInput
                    label="Ожидаемый результат"
                    name="expected_result"
                    style={{minWidth: "200px"}}
                    control={control}
                />
                <ReferenceInput 
                    label="Проект" 
                    register={register("project_ref", {required: "обязательное поле"})} 
                    referenceRequest={()=>api.projects.getProjectsApiProjectsGet()}
                    error={errors.project_ref?.message}
                />
                <div className='FormRow'>
                    <Button type='submit'>
                        Добавить Тест-кейс
                    </Button>
                    <Button type="button" onClick={()=>navigate(-1)}>
                        Отмена
                    </Button>
                </div>
            </Form>
        </FlexColumn>
    )
}

export default TestCaseForm;